import React, {useContext, useEffect, useState} from 'react'
import {graphql} from 'gatsby'
// import {css} from '@emotion/react'
import styled from '@emotion/styled'
import useInView from 'react-cool-inview'
import { globalHistory as history } from '@reach/router'

// Components
import SEO from '../components/seo'
import Layout from '../components/layout'
import Container from '../components/container'
import Footer from '../components/footer'
import Project from '../components/project'

/*
import Text from '../components/text'
import Quote from '../components/quote'
import Figure from '../components/figure'
import Carousel from '../components/carousel'
import CarouselWithArrows from '../components/carouselWithArrows'
import VideoPlayer from '../components/videoPlayer'
import Review from '../components/review'
import Award from '../components/award'
import List from '../components/list'
import FigureTile from '../components/figureTile'
*/



import theme from '../utils/theme';
import {CommonTextStyles} from '../utils/styles'

// Context
import {
  GlobalDispatchContext,
  GlobalStateContext,
} from '../context/globalContextProvider'


import projects from '../projects'












/*
 * Component
 */
const IndexPage = (props) => {

  const {
    data, 
    handleOpenModal, 
    isOpen, 
    setModalContent, 
    //disableHeadroom, // temp
    //setDisableHeadroom, // temp
    removeIntro, 
    hideStatusContainer, 
    setHideStatusContainer, 
    fieldNotes, 
    setFieldNotes,
    setCurrentProject, // used to update project title in status bar
    setRef,
    setSection,
  } = props.pageProps || props // props.pageProps is fed from router in index.js


  const state = useContext(GlobalStateContext) || {}
  const dispatch = useContext(GlobalDispatchContext)
  useEffect(() => {
    dispatch({ 
      type: 'setTheme',
      value: 'white',
    })
  }, []);





  const { location, navigate } = history


  useEffect(() => {
    setSection(location.pathname)
  }, []);


  // Hide Status Container on page load
  useEffect(() => {
    if(location.pathname === '/') {
      setHideStatusContainer(true)
      setCurrentProject(null)
      setFieldNotes(null)
    } else {
      setHideStatusContainer(false)
    }
  }, []);

  //console.log(projects.length)

  return (
    <>
      <SEO
        title={data.site.title}
        description={data.site.description}
      />

      <div style={{overflow: 'hidden' }}>
        {
          projects.map((project, index) => {
            const isFirst = (index === 0) ? true : false
            const isLast = (index === (projects.length - 1)) ? true : false

            return (
              <Project
                key={project.id}
                forwardedRef={setRef(project.id)}
                id={project.id}
                title={project.title}
                content={project.content}
                setCurrentProject={setCurrentProject}
                setHideStatusContainer={setHideStatusContainer}
                setFieldNotes={setFieldNotes}
                fieldNotes={project.fieldNotes}
                isFirst={isFirst}
                isLast={isLast}
              />
            )
          })
        }
      </div>

      <Footer />
    </>
  )
}

export default IndexPage

/*
 * Query
 */


export const query = graphql`
  fragment SanityImage on SanityMainImage {
    crop {
      _key
      _type
      top
      bottom
      left
      right
    }
    hotspot {
      _key
      _type
      x
      y
      height
      width
    }
    asset {
      _id
    }
  }

  query IndexPageQuery2 {
    site: sanitySiteSettings(_id: { regex: "/(drafts.|)siteSettings/" }) {
      title
      description
    }

    images: file(relativePath: { eq: "NatureByNature_1.jpg" }) {
      childImageSharp {
        fixed(width: 125, height: 125) {
          ...GatsbyImageSharpFixed
        }
      }
    }
  }
`
